define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GrazingAuthTermDomain = void 0;
    class GrazingAuthTermDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: GrazingAuthTermDomain._3Months, value: "3 Months" },
                    { key: GrazingAuthTermDomain._4Months, value: "4 Months" },
                    { key: GrazingAuthTermDomain._5Months, value: "5 Months" },
                    { key: GrazingAuthTermDomain._6Months, value: "6 Months" },
                    { key: GrazingAuthTermDomain._7Months, value: "7 Months" },
                    { key: GrazingAuthTermDomain._8Months, value: "8 Months" },
                    { key: GrazingAuthTermDomain._9Months, value: "9 Months" },
                    { key: GrazingAuthTermDomain._10Months, value: "10 Months" },
                    { key: GrazingAuthTermDomain._11Months, value: "11 Months" },
                    { key: GrazingAuthTermDomain._1Year, value: "1 Year" },
                    { key: GrazingAuthTermDomain._5Years, value: "5 Years" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[GrazingAuthTermDomain._3Months] = 0;
                this.KeyIndex[GrazingAuthTermDomain._4Months] = 1;
                this.KeyIndex[GrazingAuthTermDomain._5Months] = 2;
                this.KeyIndex[GrazingAuthTermDomain._6Months] = 3;
                this.KeyIndex[GrazingAuthTermDomain._7Months] = 4;
                this.KeyIndex[GrazingAuthTermDomain._8Months] = 5;
                this.KeyIndex[GrazingAuthTermDomain._9Months] = 6;
                this.KeyIndex[GrazingAuthTermDomain._10Months] = 7;
                this.KeyIndex[GrazingAuthTermDomain._11Months] = 8;
                this.KeyIndex[GrazingAuthTermDomain._1Year] = 9;
                this.KeyIndex[GrazingAuthTermDomain._5Years] = 10;
                this.ValueIndex = {};
                this.ValueIndex["3 Months"] = 0;
                this.ValueIndex["4 Months"] = 1;
                this.ValueIndex["5 Months"] = 2;
                this.ValueIndex["6 Months"] = 3;
                this.ValueIndex["7 Months"] = 4;
                this.ValueIndex["8 Months"] = 5;
                this.ValueIndex["9 Months"] = 6;
                this.ValueIndex["10 Months"] = 7;
                this.ValueIndex["11 Months"] = 8;
                this.ValueIndex["1 Year"] = 9;
                this.ValueIndex["5 Years"] = 10;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.GrazingAuthTermDomain = GrazingAuthTermDomain;
    Object.defineProperty(GrazingAuthTermDomain, "_3Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(GrazingAuthTermDomain, "_4Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(GrazingAuthTermDomain, "_5Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(GrazingAuthTermDomain, "_6Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(GrazingAuthTermDomain, "_7Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(GrazingAuthTermDomain, "_8Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(GrazingAuthTermDomain, "_9Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 9
    });
    Object.defineProperty(GrazingAuthTermDomain, "_10Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(GrazingAuthTermDomain, "_11Months", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 11
    });
    Object.defineProperty(GrazingAuthTermDomain, "_1Year", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 12
    });
    Object.defineProperty(GrazingAuthTermDomain, "_5Years", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 60
    });
    Object.defineProperty(GrazingAuthTermDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
